module.exports = __webpack_public_path__ + "static/media/display-suite-11.038b0a75.jpg";